import React from 'react';
import PropTypes from 'prop-types';

import { Translate, SafeAnchor } from '@hydra/common/components';
import { Criterium, CriteriumSkeleton, CriteriumTable } from '@hydra/common/criterium';
import { useReviewContext } from '@hydra/common/context';

export const BrokenLinks = ({ criterium }) => {
  const { data, url } = criterium;
  const { variant } = useReviewContext();

  const hasBrokenLinks = data.length > 0;
  const head = ['URL', 'Status', 'Code'];
  const body = data.map(brokenLink => ([
    <SafeAnchor key={brokenLink.href} rel='nofollow noopener noreferrer' title={brokenLink.href} target='_blank' href={brokenLink.href}>
      {variant === 'nocrit' ? <CriteriumSkeleton /> : brokenLink.href}
    </SafeAnchor>,
    <span key={brokenLink.statusCode}>{variant === 'nocrit' ? <CriteriumSkeleton /> : brokenLink.statusCode}</span>,
    <span key={brokenLink.status}>{variant === 'nocrit' ? <CriteriumSkeleton /> : brokenLink.status}</span>
  ]));
  const tableClasses = {
    head: ['', '', ''],
    body: ['nowrap', '', 'nowrap']
  };

  const content = (
    <>
      {
        hasBrokenLinks
          ? (
            <div>
              <Translate
                component='p'
                content='broken_links_summary'
                with={{ count: data.length }}
              />
              <CriteriumTable
                fixedColumns={[2, 1, 1]}
                head={head}
                rows={body}
                classNames={tableClasses}
                striped
                thinHead
                nowrap
              />
            </div>
            )
          : variant === 'nocrit' ? <CriteriumSkeleton width='70%' /> : <Translate content='broken_links_ok' />
      }
    </>
  );

  return (
    <Criterium
      criterium={criterium}
      variables={{ domain: url, brokenLinksCount: data.length.toString() }}
    >
      {content}
    </Criterium>
  );
};

BrokenLinks.propTypes = {
  criterium: PropTypes.shape({
    data: PropTypes.array
  })
};

export default React.memo(BrokenLinks);
